import { faSearch } from '@fortawesome/free-solid-svg-icons';

const filterConfig = [
    { field: "leak", type: "text", placeholder: "Identifier", icon: faSearch, view: "identifier", label: "Identifier", title: "Search by Identifier" },
    { field: "fromDate", type: "date", placeholder: "From", icon: null, view: "start_date_range_after", label: "From", title: "Select the start date" },
    { field: "toDate", type: "date", placeholder: "To", icon: null, view: "end_date_range_before", label: "To", title: "Select the end date" },
    { field: "pipe", type: "text", placeholder: "Pipe", icon: null, view: "pipe", label: "Pipe", title: "Search by Pipe" },
    { field: "aoidraw", action: "toggleDrawing", type: 'button' },
  ];

export default filterConfig;